// ---------------------------------------------------------------------------
// SpeedyDock SDK — Redirect mode
// ---------------------------------------------------------------------------

import type { RedirectOptions, EmbedInstance, EmbedEventType, EmbedEventHandler } from "./types";
import { buildEmbedUrl, resolveElement, EventEmitter } from "./utils";

export function createRedirectEmbed(
  baseUrl: string,
  shortName: string,
  options: RedirectOptions = {},
): EmbedInstance {
  const emitter = new EventEmitter();
  const target = options.target ?? "_blank";

  // Build URL without embed=true — this is a full-page redirect
  const url = buildEmbedUrl(baseUrl, shortName, options).replace("embed=true&", "").replace("?embed=true", "");

  const trigger = resolveElement(options.trigger);
  const handler = () => window.open(url, target);

  if (trigger) {
    trigger.addEventListener("click", handler);
  }

  return {
    destroy() {
      trigger?.removeEventListener("click", handler);
    },
    on<T extends EmbedEventType>(event: T, h: import("./types").EmbedEventHandler<T>) {
      emitter.on(event, h);
    },
    off<T extends EmbedEventType>(event: T, h: EmbedEventHandler<T>) {
      emitter.off(event, h);
    },
    navigate() {
      window.open(url, target);
    },
  };
}
